// extracted by mini-css-extract-plugin
export var root = "b3Jx";
export var rootButton = "HKjx";
export var rootImage = "qz7f";
export var rootPicture = "rufl";
export var rootPictureLabel = "CskD";
export var rootPictureLabelWrapper = "Ba5V";
export var rootPictureWrapper = "hm7Z";
export var rootProduct = "DzNC";
export var rootProductPrice = "_5OpT";
export var rootProductPriceRegular = "eArq";
export var rootProductPriceSale = "uEA7";
export var rootProductPriceWrapper = "VHE5";
export var rootProductTitle = "g37l";
export var rootProductVendor = "PuDO";
export var rootTileLink = "_6Cl1";
export var rootTitle = "PeP7";
export var rootWrapper = "qTli";